webpackJsonp([1],{

/***/ "8nIW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AyAo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D9zt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H5La":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HRs4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MeOw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N+Es":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store/chat.js
// temp data
var chat = ['1000', '1001'];

/* harmony default export */ var store_chat = (chat);
// CONCATENATED MODULE: ./src/store/subject.js
// temp data
var subject = [{
  userName: '每日分享',
  avatar: './static/av1.jpg',
  msg: [{
    time: '11:40',
    content: '今天也要保持好心情。'
  }, {
    time: '11:40',
    content: '分享一张今天拍的照片。'
  }]
}, {
  userName: '前端交流',
  avatar: './static/av2.jpg',
  msg: [{
    time: '11:40',
    content: '有空一起交流一下最近的项目吧。'
  }, {
    time: '11:40',
    content: '好的，晚点把资料发给你。'
  }]
}];

/* harmony default export */ var store_subject = (subject);
// CONCATENATED MODULE: ./src/store/contact.js
// temp data
var contact = {
  '1000': {
    userName: 'Charlotte',
    avatar: './static/av1.jpg',
    bio: 'Enjoy the little things in life.',
    sex: 'female',
    remarks: '',
    location: 'New Zealand'
  },
  '1001': {
    userName: 'Ethan',
    avatar: './static/av2.jpg',
    bio: '慢慢来，每天进步一点。',
    sex: 'male',
    remarks: '',
    location: '广东 深圳'
  },
  '1002': {
    userName: 'Oliver',
    avatar: './static/av3.jpg',
    bio: '螃蟹在剥我的壳，笔记本在写我，漫天的我落在雪花上。',
    sex: 'male',
    remarks: '',
    location: 'Amsterdam'
  },
  '1003': {
    userName: 'Lucas',
    avatar: './static/av4.jpg',
    bio: '今天也要好好生活。',
    sex: 'male',
    remarks: '',
    location: ''
  },
  '1004': {
    userName: 'yuxino',
    avatar: './static/yuxino.jpg',
    bio: '你好，很高兴认识你。',
    sex: 'male',
    remarks: '',
    location: '广东 深圳'
  },
  '1005': {
    userName: 'Sophie',
    avatar: './static/av6.jpg',
    bio: '',
    sex: 'female',
    remarks: '',
    location: 'Hokkaido'
  },
  '1006': {
    userName: 'Noah',
    avatar: './static/av7.jpg',
    bio: '慢热 ！',
    sex: 'male',
    remarks: '',
    location: '上海 虹口'
  }
};

/* harmony default export */ var store_contact = (contact);
// CONCATENATED MODULE: ./src/store/chatsHistory.js
var msg = function msg(str, time) {
  var self = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    msg: str,
    time: time,
    self: self
  };
};

var chatsHistory = {
  '1000': [msg('你好，最近怎么样？', new Date(), true), msg('挺好的，你呢？', new Date()), msg('我也不错，有空一起喝杯咖啡吧。', new Date(), true), msg('好呀，周末见！', new Date())],
  '1001': [msg('周末一起去散步吗？', new Date()), msg('下午两点在公园门口见吧。', new Date())]
};

/* harmony default export */ var store_chatsHistory = (chatsHistory);
// CONCATENATED MODULE: ./src/store/state.js





var state_state = {
  // 当前视图
  currentView: 'chat',
  // 各种视图列表的数据
  chat: store_chat,
  subject: store_subject,
  contact: store_contact,
  chatsHistory: store_chatsHistory,
  // 各种视图列表选中的条目
  currentChatId: null,
  currentSubjectId: null,
  currentContactId: null,
  // 按钮相关状态
  menuStatus: false,
  currentMenu: 'ChatListMenu',
  menuPosition: { top: '0px', left: '0px' },
  // 卡片相关状态
  cardChatId: null,
  cardStatus: false,
  cardPosition: { top: '0px', left: '0px' }
};

/* harmony default export */ var store_state = (state_state);
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/pyfl/src/index.js
var src = __webpack_require__("dD7F");
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// CONCATENATED MODULE: ./src/store/getters.js




// 获取拼音首字母
// 如果有且为[a-zA-Z]範圍内的字符则返回小写的字母
// 否则统一返回 ~
var getters_getFirstLetter = function getFirstLetter(char) {
  var result = src_default()(char).charAt(0);
  return (/[a-zA-Z]/.test(result) ? result.toUpperCase() : '~'
  );
};

var getters_sortByKey = function sortByKey(collection) {
  // 排序
  // 相关方案https://github.com/lodash/lodash/issues/1459
  return lodash_default()(collection).toPairs().sortBy(0).fromPairs().value();
};

// 格式化时间
var formatTime = function formatTime(date) {
  var hour = ('' + date.getHours()).padStart(2, '0');
  var minutes = ('' + date.getMinutes()).padStart(2, '0');
  return hour + ':' + minutes;
};

var getters = {
  // `最近`联系人列表
  chatList: function chatList(state) {
    var chats = {};
    state.chat.forEach(function (chatId) {
      var lastMessage = lodash_default.a.last(state.chatsHistory[chatId]);
      if (lastMessage) {
        chats['_' + chatId] = extends_default()({}, state.contact[chatId], { // 獲取chatId對應的用户信息
          time: formatTime(lastMessage.time),
          content: lastMessage.msg
        });
      } else {
        chats['_' + chatId] = extends_default()({}, state.contact[chatId], { // 獲取chatId對應的用户信息
          time: '',
          content: ''
        });
      }
    });
    return chats;
  },
  // 联系人列表
  contactList: function contactList(state) {
    var contacts = {};
    lodash_default.a.forEach(state.contact, function (item, userId) {
      // 如果有备注 则优先备注
      var firstLetter = item.remarks !== '' ? getters_getFirstLetter(item.remarks) : getters_getFirstLetter(item.userName);
      if (!contacts[firstLetter]) {
        contacts[firstLetter] = {};
      }
      contacts[firstLetter][userId] = item;
    });
    // TODO 这是一个可优化的选项
    return getters_sortByKey(contacts);
  },
  currentChat: function currentChat(state) {
    return state.contact[state.currentChatId] ? state.contact[state.currentChatId] : '';
  },
  currentContact: function currentContact(state) {
    return state.currentContactId ? state.contact[state.currentContactId] : '';
  },
  historys: function historys(state) {
    return state.chatsHistory[state.currentChatId];
  }
};

/* harmony default export */ var store_getters = (getters);
// CONCATENATED MODULE: ./src/store/mutations.js



// 置顶列表里面和id相等的一项
var topOnList = function topOnList(list, id) {
  deleteOnList(list, id);
  list.unshift(id);
};
// 删除里面对应的id
var deleteOnList = function deleteOnList(list, id) {
  for (var i = 0; i < list.length; i++) {
    if (list[i] === id) {
      // 移除相等的值
      list.splice(i, 1);
      break;
    }
  }
};
// 查询字符串内是否包含指定字符
var mutations_container = function container(str, target) {
  return String(str).indexOf(target) >= 0;
};
var mutations = {
  viewChange: function viewChange(state, viewName) {
    state.currentView = viewName;
  },
  chatChange: function chatChange(state, chatId) {
    state.currentChatId = chatId;
  },
  subjectChange: function subjectChange(state, subjectId) {
    state.currentSubjectId = subjectId;
  },
  contactChange: function contactChange(state, contactId) {
    state.currentContactId = contactId;
  },
  showMenu: function showMenu(state, _ref) {
    var $event = _ref.$event,
        chatId = _ref.chatId,
        menuName = _ref.menuName;

    var e = event;
    state.menuStatus = true;
    state.currentMenu = menuName;
    state.menuPosition = { top: e.clientY + 'px', left: e.clientX + 'px' };
    state.menuChatId = mutations_container(chatId, '_') ? chatId.substr(1) : chatId;
  },
  closeMenu: function closeMenu(state) {
    state.menuStatus = false;
  },
  sendMessage: function sendMessage(state, message) {
    // 将当前聊天对象置顶
    topOnList(state.chat, state.currentChatId);
    lodash_default.a.isEmpty(state.chatsHistory[state.currentChatId]) && vue_esm["a" /* default */].set(state.chatsHistory, state.currentChatId, []);
    var history = state.chatsHistory[state.currentChatId];
    history.push({ msg: message, time: new Date(), self: true });

    // 强行触发Getter更新
    var id = state.currentChatId;
    state.currentChatId = 0;
    state.currentChatId = id;
  },
  newChat: function newChat(state, chatId) {
    // 聊天对象切换
    topOnList(state.chat, chatId);
    // 视图切换
    state.currentChatId = chatId;
    state.currentView = 'chat';
  },
  closeChat: function closeChat(state) {
    deleteOnList(state.chat, state.menuChatId);
    // clear history
    vue_esm["a" /* default */].delete(state.chatsHistory, state.menuChatId);
    state.currentChatId = void 0;
    state.menuStatus = false;
  },
  clearHistory: function clearHistory(state, chatId) {
    vue_esm["a" /* default */].delete(state.chatsHistory, chatId);
    // close Menu
    state.menuStatus = false;
  },
  showCard: function showCard(state, _ref2) {
    var $event = _ref2.$event,
        currentChatId = _ref2.currentChatId;

    var e = event;
    state.cardChatId = currentChatId;
    state.cardStatus = true;
    state.cardPosition = { top: e.clientY + 'px', left: e.clientX + 'px' };
  },
  closeCard: function closeCard(state) {
    state.cardStatus = false;
  },

  // TODO 还没想好怎么做这里
  addContact: function addContact(state) {
    // Vue.set(state.contact ,  , {
    //     userName: 'Noah',
    //     avatar  : '/static/av7.jpg',
    //     bio     : '慢热 ！',
    //     sex     : 'male',
    //     remarks : '',
    //     location: '上海 虹口'
    // })
  }
};

/* harmony default export */ var store_mutations = (mutations);
// CONCATENATED MODULE: ./src/store/index.js






vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
  state: store_state,
  getters: store_getters,
  mutations: store_mutations
});

/* harmony default export */ var src_store = (store);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/aside/Profile.vue

//
//
//
//
//
//
//
//


/* harmony default export */ var Profile = ({
  name: 'Profile',
  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])(['showCard']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e50e195","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aside/Profile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-profile clearfix"},[_c('img',{staticClass:"wx-profile__avatar",attrs:{"src":"static/yuxino.jpg","alt":""},on:{"click":function($event){$event.stopPropagation();_vm.showCard($event)}}}),_vm._v(" "),_c('span',{staticClass:"wx-profile__username"},[_vm._v("yuxino")]),_vm._v(" "),_c('i',{staticClass:"wx-profile__menu iconfont icon-menu"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var aside_Profile = (esExports);
// CONCATENATED MODULE: ./src/components/aside/Profile.vue
function injectStyle (ssrContext) {
  __webpack_require__("qMp1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Profile,
  aside_Profile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_aside_Profile = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/aside/Search.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Search = ({
  name: 'Search',
  data: function data() {
    return {
      // 是否显示搜索结果框
      show: false,
      keyword: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['contact']), {
    isEmpty: function isEmpty(_ref) {
      var result = _ref.result;
      return lodash_default.a.isEmpty(result);
    },
    result: function result() {
      var _this = this;

      var keyword = lodash_default.a.trim(this.keyword);
      if (lodash_default.a.isEmpty(keyword)) {
        this.show = false;
        return;
      }
      // 不爲空顯示搜索結果框
      this.show = true;
      // 查询出对应的联系人信息
      var py = src_default()(keyword);
      var regex = new RegExp(py, 'i');
      var results = {};
      lodash_default.a.filter(this.contact, function (_ref2, contactId) {
        var remarks = _ref2.remarks,
            userName = _ref2.userName;

        var valid = regex.test(src_default()(remarks || userName));
        valid && (results[contactId] = _this.contact[contactId]);
        return valid;
      });
      return results;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])(['newChat']), {
    _newChat: function _newChat(contactId) {
      this.newChat(contactId);
      this.closeSearch();
    },
    closeSearch: function closeSearch() {
      this.show = false;
    },

    search: lodash_default.a.debounce(function (e) {
      this.keyword = e.target.value;
    }, 200)
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ca1ff51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aside/Search.vue
var Search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeSearch),expression:"closeSearch"}],staticClass:"wx-search"},[_c('i',{staticClass:"iconfont icon-sousuo wx-search__icon"}),_vm._v(" "),_c('input',{staticClass:"wx-search__input",attrs:{"type":"text","placeholder":"搜索","spellcheck":"false"},on:{"input":_vm.search}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"wx-search-container"},[(_vm.isEmpty)?_c('div',{staticClass:"wx-search-container__et"},[_vm._v("找不到匹配的结果")]):_c('div',{staticClass:"wx-search-result"},[_c('div',{staticClass:"wx-search-result__tips"},[_vm._v("\n        好友\n      ")]),_vm._v(" "),_vm._l((_vm.result),function(item,contactId,index){return _c('div',{key:contactId,staticClass:"wx-search-result-item clearfix",class:{'is-first': index === 0},on:{"click":function($event){_vm._newChat(contactId)}}},[_c('img',{staticClass:"wx-search-result-item__avatar",attrs:{"src":item.avatar}}),_vm._v(" "),_c('div',{staticClass:"wx-search-result-item__username"},[_vm._v(_vm._s(item.remarks || item.userName))])])})],2)])])}
var Search_staticRenderFns = []
var Search_esExports = { render: Search_render, staticRenderFns: Search_staticRenderFns }
/* harmony default export */ var aside_Search = (Search_esExports);
// CONCATENATED MODULE: ./src/components/aside/Search.vue
function Search_injectStyle (ssrContext) {
  __webpack_require__("brbV")
}
var Search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Search___vue_template_functional__ = false
/* styles */
var Search___vue_styles__ = Search_injectStyle
/* scopeId */
var Search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Search___vue_module_identifier__ = null
var Search_Component = Search_normalizeComponent(
  Search,
  aside_Search,
  Search___vue_template_functional__,
  Search___vue_styles__,
  Search___vue_scopeId__,
  Search___vue_module_identifier__
)

/* harmony default export */ var components_aside_Search = (Search_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/aside/Tab.vue

//
//
//
//
//
//
//
//



/* harmony default export */ var Tab = ({
  name: 'Tab',
  data: function data() {
    return {
      views: [{
        viewName: 'chat',
        iconName: 'icon-qipao'
      }, {
        viewName: 'subject',
        iconName: 'icon-wenzhang_weixuanzhong'
      }, {
        viewName: 'contact',
        iconName: 'icon-lianxiren'
      }]
    };
  },

  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['currentView'])),
  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])(['viewChange']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7ba4756","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aside/Tab.vue
var Tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-aside-tab clearfix"},_vm._l((_vm.views),function(ref,index){
var iconName = ref.iconName;
var viewName = ref.viewName;
return _c('div',{key:index,staticClass:"wx-aside-tab-container",on:{"click":function($event){_vm.viewChange(viewName)}}},[_c('i',{staticClass:"iconfont wx-aside-tab-container__icons",class:[iconName,{'is-active' : viewName === _vm.currentView}]})])}))}
var Tab_staticRenderFns = []
var Tab_esExports = { render: Tab_render, staticRenderFns: Tab_staticRenderFns }
/* harmony default export */ var aside_Tab = (Tab_esExports);
// CONCATENATED MODULE: ./src/components/aside/Tab.vue
function Tab_injectStyle (ssrContext) {
  __webpack_require__("MeOw")
}
var Tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Tab___vue_template_functional__ = false
/* styles */
var Tab___vue_styles__ = Tab_injectStyle
/* scopeId */
var Tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Tab___vue_module_identifier__ = null
var Tab_Component = Tab_normalizeComponent(
  Tab,
  aside_Tab,
  Tab___vue_template_functional__,
  Tab___vue_styles__,
  Tab___vue_scopeId__,
  Tab___vue_module_identifier__
)

/* harmony default export */ var components_aside_Tab = (Tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/aside/Header.vue
//
//
//
//
//
//
//
//




/* harmony default export */ var Header = ({
  name: 'Header',
  components: { Profile: components_aside_Profile, Tab: components_aside_Tab, Search: components_aside_Search }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cd007e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aside/Header.vue
var Header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-aside-header"},[_c('profile'),_vm._v(" "),_c('search'),_vm._v(" "),_c('tab')],1)}
var Header_staticRenderFns = []
var Header_esExports = { render: Header_render, staticRenderFns: Header_staticRenderFns }
/* harmony default export */ var aside_Header = (Header_esExports);
// CONCATENATED MODULE: ./src/components/aside/Header.vue
function Header_injectStyle (ssrContext) {
  __webpack_require__("j4e9")
}
var Header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Header___vue_template_functional__ = false
/* styles */
var Header___vue_styles__ = Header_injectStyle
/* scopeId */
var Header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Header___vue_module_identifier__ = null
var Header_Component = Header_normalizeComponent(
  Header,
  aside_Header,
  Header___vue_template_functional__,
  Header___vue_styles__,
  Header___vue_scopeId__,
  Header___vue_module_identifier__
)

/* harmony default export */ var components_aside_Header = (Header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/aside/ChatList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ChatList = ({
  name: 'ChatList',
  data: function data() {
    return {
      tips: '暂无聊天',
      menuName: 'ChatListMenu'
    };
  },

  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['currentChatId']), Object(vuex_esm["b" /* mapGetters */])(['chatList']), {
    itemsEmpty: function itemsEmpty() {
      return lodash_default.a.isEmpty(this.chatList);
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])(['showMenu', 'chatChange']), {
    // 删掉id前面的'_' 设置'_'的原因具体可以看getter.js里面的做法
    // 加_的原因是因为chrome和一些浏览器会对对象自动排序
    // 这里依赖了对象的id，并且这个id是数字,排序的结果会导致乱掉
    _chatId: function _chatId(chatId) {
      return chatId.substr(1);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-103900f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aside/ChatList.vue
var ChatList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-chat"},[(_vm.itemsEmpty)?_c('div',{staticClass:"wx-chat-list__tips"},[_vm._v(_vm._s(_vm.tips))]):_vm._e(),_vm._v(" "),_vm._l((_vm.chatList),function(item,chatId){return _c('div',{key:_vm._chatId(chatId),staticClass:"wx-chat-list__item",class:{ 'is-active' : _vm._chatId(chatId) === _vm.currentChatId },on:{"contextmenu":function($event){$event.preventDefault();_vm.showMenu({$event: $event,chatId: chatId,menuName: _vm.menuName})},"click":function($event){_vm.chatChange(_vm._chatId(chatId))}}},[_c('img',{staticClass:"wx-chat-list__avatar",attrs:{"src":item.avatar,"alt":"头像"}}),_vm._v(" "),_c('div',{staticClass:"wx-chat-list-info"},[_c('span',{staticClass:"wx-chat-list-info__username"},[_vm._v("\n          "+_vm._s(item.remarks || item.userName)+"\n        "),_c('span',{staticClass:"wx-chat-list-info__time"},[_vm._v("\n          "+_vm._s(item.time)+"\n        ")])]),_vm._v(" "),_c('span',{staticClass:"wx-chat-list-info__lastMsg"},[_vm._v("\n          "+_vm._s(item.content)+"\n      ")])])])})],2)}
var ChatList_staticRenderFns = []
var ChatList_esExports = { render: ChatList_render, staticRenderFns: ChatList_staticRenderFns }
/* harmony default export */ var aside_ChatList = (ChatList_esExports);
// CONCATENATED MODULE: ./src/components/aside/ChatList.vue
function ChatList_injectStyle (ssrContext) {
  __webpack_require__("WsHK")
}
var ChatList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChatList___vue_template_functional__ = false
/* styles */
var ChatList___vue_styles__ = ChatList_injectStyle
/* scopeId */
var ChatList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChatList___vue_module_identifier__ = null
var ChatList_Component = ChatList_normalizeComponent(
  ChatList,
  aside_ChatList,
  ChatList___vue_template_functional__,
  ChatList___vue_styles__,
  ChatList___vue_scopeId__,
  ChatList___vue_module_identifier__
)

/* harmony default export */ var components_aside_ChatList = (ChatList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/aside/SubjectList.vue

//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var SubjectList = ({
  name: 'SubjectList',
  data: function data() {
    return {
      emptyTips: '暂无文章...',
      items: []
    };
  },

  methods: {
    subjectChange: function subjectChange(subjectId) {
      this.$store.commit('subjectChange', subjectId);
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['currentSubject', 'subject']), {
    isEmpty: function isEmpty() {
      return lodash_default.a.isEmpty(this.items);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cce56e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aside/SubjectList.vue
var SubjectList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-subject-list"},[(_vm.isEmpty)?_c('div',{staticClass:"wx-subject-list__et"},[_vm._v(_vm._s(_vm.emptyTips))]):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item,subjectId){return _c('div',{key:subjectId,staticClass:"wx-subject-list__item",on:{"click":function($event){_vm.subjectChange(subjectId)}}})})],2)}
var SubjectList_staticRenderFns = []
var SubjectList_esExports = { render: SubjectList_render, staticRenderFns: SubjectList_staticRenderFns }
/* harmony default export */ var aside_SubjectList = (SubjectList_esExports);
// CONCATENATED MODULE: ./src/components/aside/SubjectList.vue
function SubjectList_injectStyle (ssrContext) {
  __webpack_require__("e50P")
}
var SubjectList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SubjectList___vue_template_functional__ = false
/* styles */
var SubjectList___vue_styles__ = SubjectList_injectStyle
/* scopeId */
var SubjectList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SubjectList___vue_module_identifier__ = null
var SubjectList_Component = SubjectList_normalizeComponent(
  SubjectList,
  aside_SubjectList,
  SubjectList___vue_template_functional__,
  SubjectList___vue_styles__,
  SubjectList___vue_scopeId__,
  SubjectList___vue_module_identifier__
)

/* harmony default export */ var components_aside_SubjectList = (SubjectList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/aside/ContactList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ContactList = ({
  name: 'ContactList',
  data: function data() {
    return {
      emptyTips: '暂无联系人'
    };
  },

  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['currentContactId']), Object(vuex_esm["b" /* mapGetters */])(['contactList']), {
    isEmpty: function isEmpty() {
      return lodash_default.a.isEmpty(this.contactList);
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])(['contactChange']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f6c4ad4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aside/ContactList.vue
var ContactList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-contact-list"},[(_vm.isEmpty)?_c('div',{staticClass:"wx-contact-list__tips"},[_vm._v(_vm._s(_vm.emptyTips))]):_vm._e(),_vm._v(" "),_vm._l((_vm.contactList),function(contacts,group){return _c('div',{key:group},[_c('h4',{staticClass:"wx-contact-list__group-title"},[_vm._v(_vm._s(group))]),_vm._v(" "),_vm._l((contacts),function(item,contactId){return _c('div',{key:contactId,staticClass:"wx-contact-list__item clearfix",class:{'is-active' : contactId == _vm.currentContactId},on:{"click":function($event){_vm.contactChange(contactId)}}},[_c('img',{staticClass:"wx-contact-list__item__avatar",attrs:{"src":item.avatar}}),_vm._v(" "),_c('div',{staticClass:"wx-contact-list__item__name"},[_vm._v(_vm._s(item.remarks ? item.remarks : item.userName))])])})],2)})],2)}
var ContactList_staticRenderFns = []
var ContactList_esExports = { render: ContactList_render, staticRenderFns: ContactList_staticRenderFns }
/* harmony default export */ var aside_ContactList = (ContactList_esExports);
// CONCATENATED MODULE: ./src/components/aside/ContactList.vue
function ContactList_injectStyle (ssrContext) {
  __webpack_require__("8nIW")
}
var ContactList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContactList___vue_template_functional__ = false
/* styles */
var ContactList___vue_styles__ = ContactList_injectStyle
/* scopeId */
var ContactList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContactList___vue_module_identifier__ = null
var ContactList_Component = ContactList_normalizeComponent(
  ContactList,
  aside_ContactList,
  ContactList___vue_template_functional__,
  ContactList___vue_styles__,
  ContactList___vue_scopeId__,
  ContactList___vue_module_identifier__
)

/* harmony default export */ var components_aside_ContactList = (ContactList_Component.exports);

// CONCATENATED MODULE: ./src/config/viewConfig.js
// 视图对应的组件名
// 这个配置用在了 main.vue 和 aside.vue 里面
/* harmony default export */ var viewConfig = ({
  chat: {
    aside: 'ChatList',
    main: 'ChatArea'
  },
  contact: {
    aside: 'ContactList',
    main: 'ContactArea'
  },
  subject: {
    aside: 'SubjectList',
    main: 'SubjectArea'
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/aside/Aside.vue

//
//
//
//
//
//
//
//
//







/* harmony default export */ var Aside = ({
  name: 'Aside',
  components: { AsideHeader: components_aside_Header, ChatList: components_aside_ChatList, SubjectList: components_aside_SubjectList, ContactList: components_aside_ContactList },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['currentView']), {
    // 根据state里面的currentView切换视图
    viewName: function viewName() {
      return viewConfig[this.currentView]['aside'];
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef30be96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aside/Aside.vue
var Aside_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-aside clearfix"},[_c('aside-header'),_vm._v(" "),_c('keep-alive',[_c(_vm.viewName,{tag:"component"})],1)],1)}
var Aside_staticRenderFns = []
var Aside_esExports = { render: Aside_render, staticRenderFns: Aside_staticRenderFns }
/* harmony default export */ var aside_Aside = (Aside_esExports);
// CONCATENATED MODULE: ./src/components/aside/Aside.vue
function Aside_injectStyle (ssrContext) {
  __webpack_require__("Q9Et")
}
var Aside_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Aside___vue_template_functional__ = false
/* styles */
var Aside___vue_styles__ = Aside_injectStyle
/* scopeId */
var Aside___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Aside___vue_module_identifier__ = null
var Aside_Component = Aside_normalizeComponent(
  Aside,
  aside_Aside,
  Aside___vue_template_functional__,
  Aside___vue_styles__,
  Aside___vue_scopeId__,
  Aside___vue_module_identifier__
)

/* harmony default export */ var components_aside_Aside = (Aside_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/main/Title.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var Title = ({
  name: 'content-title'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9a53872","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Title.vue
var Title_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-main-title"},[_c('span',[_vm._t("default")],2)])}
var Title_staticRenderFns = []
var Title_esExports = { render: Title_render, staticRenderFns: Title_staticRenderFns }
/* harmony default export */ var main_Title = (Title_esExports);
// CONCATENATED MODULE: ./src/components/main/Title.vue
function Title_injectStyle (ssrContext) {
  __webpack_require__("Ql+W")
}
var Title_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Title___vue_template_functional__ = false
/* styles */
var Title___vue_styles__ = Title_injectStyle
/* scopeId */
var Title___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Title___vue_module_identifier__ = null
var Title_Component = Title_normalizeComponent(
  Title,
  main_Title,
  Title___vue_template_functional__,
  Title___vue_styles__,
  Title___vue_scopeId__,
  Title___vue_module_identifier__
)

/* harmony default export */ var components_main_Title = (Title_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/main/ChatArea.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 缓存textarea的输入，因为是共用的textarea
var messageCache = {};

/* harmony default export */ var ChatArea = ({
  name: 'ChatArea',
  components: { ChatTitle: components_main_Title },
  data: function data() {
    return {
      menuShow: false,
      menuName: 'ChatAreaMenu'
    };
  },

  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['currentChatId', 'contact']), Object(vuex_esm["b" /* mapGetters */])(['currentChat', 'historys'])),
  watch: {
    // 监视当前聊天对象的变更
    currentChatId: function currentChatId() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var container, textarea;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.currentChatId) {
                  _context.next = 8;
                  break;
                }

                _context.next = 3;
                return _this.$nextTick();

              case 3:
                // 修正滚动条位置
                container = _this.$refs.container;

                container.scrollTop = container.scrollHeight;
                // 设置 textarea 内保存过的信息
                textarea = _this.$refs.textarea;

                textarea.value = messageCache[_this.currentChatId] || '';
                textarea.focus();

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])(['showMenu', 'showCard']), {
    type: function type(e) {
      messageCache[this.currentChatId] = e.target.value;
    },
    submit: function submit(e) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var textarea, container;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$store.commit('sendMessage', messageCache[_this2.currentChatId]);
                // 清空聊天框内容
                textarea = _this2.$refs.textarea;

                textarea.value = '';
                // 清空缓存
                messageCache[_this2.currentChatId] = '';
                // 等待数据渲染完成后 调整滚动条
                _context2.next = 6;
                return _this2.$nextTick();

              case 6:
                container = _this2.$refs.container;

                container.scrollTop = container.scrollHeight;

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aaa89930","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/ChatArea.vue
var ChatArea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('chat-title',[_c('span',{on:{"click":function($event){$event.stopPropagation();_vm.showCard({$event: $event,currentChatId: _vm.currentChatId})}}},[_vm._v(_vm._s(_vm.currentChat.remarks || _vm.currentChat.userName))])]),_vm._v(" "),(_vm.currentChatId)?_c('div',{ref:"container",staticClass:"wx-chatArea-content",on:{"contextmenu":function($event){$event.preventDefault();_vm.showMenu({$event: $event,menuName: _vm.menuName})}}},[_c('p',{staticClass:"wx-chatArea-content__time"},[_vm._v("11:23")]),_vm._v(" "),_vm._l((_vm.historys),function(item,index){return _c('div',{key:index,staticClass:"wx-chatArea-message clearfix",class:{'is-self' : item.self }},[_c('img',{staticClass:"wx-chatArea-message__avatar",attrs:{"src":item.self ? './static/yuxino.jpg' : _vm.contact[_vm.currentChatId].avatar}}),_vm._v(" "),_c('div',{staticClass:"wx-chatArea-message__bubble"},[_vm._v(_vm._s(item.msg))])])})],2):_vm._e(),_vm._v(" "),(_vm.currentChatId)?_c('div',{staticClass:"wx-chatArea-messageArea"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"wx-chatArea-messageArea-text-box"},[_c('div',{staticClass:"wx-chatArea-messageArea-text-box__wrapper"},[_c('textarea',{ref:"textarea",attrs:{"spellcheck":"false"},on:{"input":_vm.type,"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }if(!$event.ctrlKey){ return null; }_vm.submit($event)}}})])]),_vm._v(" "),_c('div',{staticClass:"wx-chatArea-messageArea-btn-container"},[_c('span',{staticClass:"wx-chatArea-messageArea-btn-container__describe"},[_vm._v("按下Ctrl+Enter发送")]),_vm._v(" "),_c('button',{staticClass:"wx-chatArea-messageArea-btn-container__send",on:{"click":_vm.submit}},[_vm._v("发送")])])]):_c('div',{staticClass:"wx-chatArea-tip-wrapper"},[_c('i',{staticClass:"wx-chatArea-tip-wrapper__icon iconfont icon-weixin"}),_vm._v(" "),_c('p',{staticClass:"wx-chatArea-tip-wrapper__tip"},[_vm._v("未选择聊天")])])],1)}
var ChatArea_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-chatArea-messageArea__bar"},[_c('i',{staticClass:"wx-chatArea-messageArea__icon iconfont icon-face"})])}]
var ChatArea_esExports = { render: ChatArea_render, staticRenderFns: ChatArea_staticRenderFns }
/* harmony default export */ var main_ChatArea = (ChatArea_esExports);
// CONCATENATED MODULE: ./src/components/main/ChatArea.vue
function ChatArea_injectStyle (ssrContext) {
  __webpack_require__("D9zt")
}
var ChatArea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChatArea___vue_template_functional__ = false
/* styles */
var ChatArea___vue_styles__ = ChatArea_injectStyle
/* scopeId */
var ChatArea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChatArea___vue_module_identifier__ = null
var ChatArea_Component = ChatArea_normalizeComponent(
  ChatArea,
  main_ChatArea,
  ChatArea___vue_template_functional__,
  ChatArea___vue_styles__,
  ChatArea___vue_scopeId__,
  ChatArea___vue_module_identifier__
)

/* harmony default export */ var components_main_ChatArea = (ChatArea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/main/SubjectArea.vue
//
//
//
//
//
//
//



/* harmony default export */ var SubjectArea = ({
  name: 'SubjectArea',
  components: { SubjectTitle: components_main_Title }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdd1efc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/SubjectArea.vue
var SubjectArea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('subject-title')],1)}
var SubjectArea_staticRenderFns = []
var SubjectArea_esExports = { render: SubjectArea_render, staticRenderFns: SubjectArea_staticRenderFns }
/* harmony default export */ var main_SubjectArea = (SubjectArea_esExports);
// CONCATENATED MODULE: ./src/components/main/SubjectArea.vue
function SubjectArea_injectStyle (ssrContext) {
  __webpack_require__("WE++")
}
var SubjectArea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SubjectArea___vue_template_functional__ = false
/* styles */
var SubjectArea___vue_styles__ = SubjectArea_injectStyle
/* scopeId */
var SubjectArea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SubjectArea___vue_module_identifier__ = null
var SubjectArea_Component = SubjectArea_normalizeComponent(
  SubjectArea,
  main_SubjectArea,
  SubjectArea___vue_template_functional__,
  SubjectArea___vue_styles__,
  SubjectArea___vue_scopeId__,
  SubjectArea___vue_module_identifier__
)

/* harmony default export */ var components_main_SubjectArea = (SubjectArea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/main/ContactArea.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContactArea = ({
  name: 'ContactArea',
  components: { ContactTitle: components_main_Title },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['currentContactId']), Object(vuex_esm["b" /* mapGetters */])(['currentContact'])),
  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])(['newChat']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-250d58f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/ContactArea.vue
var ContactArea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('contact-title',[_vm._v("详细信息")]),_vm._v(" "),(_vm.currentContact)?_c('div',{staticClass:"wx-contactArea"},[_c('img',{staticClass:"wx-contactArea__avatar",attrs:{"src":_vm.currentContact.avatar,"alt":""}}),_vm._v(" "),_c('div',[_c('h4',{staticClass:"wx-contactArea__username"},[_vm._v(_vm._s(_vm.currentContact.userName))]),_vm._v(" "),_c('i',{staticClass:"iconfont wx-contactArea__icon",class:[_vm.currentContact.sex === 'male' ? 'icon-nanren is-male' : 'icon-nvrentouxiang is-female']})]),_vm._v(" "),(_vm.currentContact.bio)?_c('p',{staticClass:"wx-contactArea__bio"},[_vm._v(_vm._s(_vm.currentContact.bio))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wx-contactArea__another-info"},[(_vm.currentContact.remarks)?_c('p',[_c('label',[_vm._v("备注 :   ")]),_vm._v(_vm._s(_vm.currentContact.remarks))]):_vm._e(),_vm._v(" "),(_vm.currentContact.location)?_c('p',[_c('label',[_vm._v("地区 :   ")]),_vm._v(_vm._s(_vm.currentContact.location))]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"wx-contactArea__newChat-btn",on:{"click":function($event){_vm.newChat(_vm.currentContactId)}}},[_vm._v("发消息")])]):_c('div',{staticClass:"wx-contactArea-tip-wrapper"},[_c('i',{staticClass:"iconfont icons icon-yonghurenxiang wx-contactArea-tip-wrapper__icon"})])],1)}
var ContactArea_staticRenderFns = []
var ContactArea_esExports = { render: ContactArea_render, staticRenderFns: ContactArea_staticRenderFns }
/* harmony default export */ var main_ContactArea = (ContactArea_esExports);
// CONCATENATED MODULE: ./src/components/main/ContactArea.vue
function ContactArea_injectStyle (ssrContext) {
  __webpack_require__("Voy+")
}
var ContactArea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContactArea___vue_template_functional__ = false
/* styles */
var ContactArea___vue_styles__ = ContactArea_injectStyle
/* scopeId */
var ContactArea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContactArea___vue_module_identifier__ = null
var ContactArea_Component = ContactArea_normalizeComponent(
  ContactArea,
  main_ContactArea,
  ContactArea___vue_template_functional__,
  ContactArea___vue_styles__,
  ContactArea___vue_scopeId__,
  ContactArea___vue_module_identifier__
)

/* harmony default export */ var components_main_ContactArea = (ContactArea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/main/Main.vue

//
//
//
//
//
//







/* harmony default export */ var Main = ({
  name: 'Main',
  components: { ChatArea: components_main_ChatArea, SubjectArea: components_main_SubjectArea, ContactArea: components_main_ContactArea },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['currentView']), {
    viewName: function viewName() {
      return viewConfig[this.currentView]['main'];
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c78ef1b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Main.vue
var Main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[_c(_vm.viewName,{tag:"component",staticClass:"wx-main"})],1)}
var Main_staticRenderFns = []
var Main_esExports = { render: Main_render, staticRenderFns: Main_staticRenderFns }
/* harmony default export */ var main_Main = (Main_esExports);
// CONCATENATED MODULE: ./src/components/main/Main.vue
function Main_injectStyle (ssrContext) {
  __webpack_require__("NvS5")
}
var Main_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Main___vue_template_functional__ = false
/* styles */
var Main___vue_styles__ = Main_injectStyle
/* scopeId */
var Main___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Main___vue_module_identifier__ = null
var Main_Component = Main_normalizeComponent(
  Main,
  main_Main,
  Main___vue_template_functional__,
  Main___vue_styles__,
  Main___vue_scopeId__,
  Main___vue_module_identifier__
)

/* harmony default export */ var components_main_Main = (Main_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/footer/CopyRight.vue
//
//
//
//

/* harmony default export */ var CopyRight = ({
  name: 'CopyRight'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc03dcca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/CopyRight.vue
var CopyRight_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"wx-copyright"},[_vm._v("© 1998 - 2017 Tencent Inc. All Rights Reserved 帮助")])}
var CopyRight_staticRenderFns = []
var CopyRight_esExports = { render: CopyRight_render, staticRenderFns: CopyRight_staticRenderFns }
/* harmony default export */ var footer_CopyRight = (CopyRight_esExports);
// CONCATENATED MODULE: ./src/components/footer/CopyRight.vue
function CopyRight_injectStyle (ssrContext) {
  __webpack_require__("H5La")
}
var CopyRight_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CopyRight___vue_template_functional__ = false
/* styles */
var CopyRight___vue_styles__ = CopyRight_injectStyle
/* scopeId */
var CopyRight___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CopyRight___vue_module_identifier__ = null
var CopyRight_Component = CopyRight_normalizeComponent(
  CopyRight,
  footer_CopyRight,
  CopyRight___vue_template_functional__,
  CopyRight___vue_styles__,
  CopyRight___vue_scopeId__,
  CopyRight___vue_module_identifier__
)

/* harmony default export */ var components_footer_CopyRight = (CopyRight_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/menu/Menu.vue

//
//
//
//
//
//
//
//
//



/* harmony default export */ var Menu = ({
  name: 'Menu',
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['menuStatus', 'menuPosition', 'menuStatus'])),
  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])(['closeMenu']), {
    // 防止疯狂提交commit
    _closeMenu: function _closeMenu() {
      this.menuStatus && this.$store.commit('closeMenu');
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b6a72f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/Menu.vue
var Menu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuStatus),expression:"menuStatus"},{name:"click-outside",rawName:"v-click-outside",value:(_vm._closeMenu),expression:"_closeMenu"}],staticClass:"wx-menu",style:(_vm.menuPosition),attrs:{"position":_vm.menuPosition}},[_vm._t("default")],2)}
var Menu_staticRenderFns = []
var Menu_esExports = { render: Menu_render, staticRenderFns: Menu_staticRenderFns }
/* harmony default export */ var menu_Menu = (Menu_esExports);
// CONCATENATED MODULE: ./src/components/menu/Menu.vue
function Menu_injectStyle (ssrContext) {
  __webpack_require__("UD+7")
}
var Menu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Menu___vue_template_functional__ = false
/* styles */
var Menu___vue_styles__ = Menu_injectStyle
/* scopeId */
var Menu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Menu___vue_module_identifier__ = null
var Menu_Component = Menu_normalizeComponent(
  Menu,
  menu_Menu,
  Menu___vue_template_functional__,
  Menu___vue_styles__,
  Menu___vue_scopeId__,
  Menu___vue_module_identifier__
)

/* harmony default export */ var components_menu_Menu = (Menu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/menu/MenuItem.vue
//
//
//
//
//
//

/* harmony default export */ var MenuItem = ({
  name: 'Menu-Item'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e8b2264","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/MenuItem.vue
var MenuItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"wx-menu-item"},[_vm._t("default")],2)}
var MenuItem_staticRenderFns = []
var MenuItem_esExports = { render: MenuItem_render, staticRenderFns: MenuItem_staticRenderFns }
/* harmony default export */ var menu_MenuItem = (MenuItem_esExports);
// CONCATENATED MODULE: ./src/components/menu/MenuItem.vue
function MenuItem_injectStyle (ssrContext) {
  __webpack_require__("AyAo")
}
var MenuItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MenuItem___vue_template_functional__ = false
/* styles */
var MenuItem___vue_styles__ = MenuItem_injectStyle
/* scopeId */
var MenuItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MenuItem___vue_module_identifier__ = null
var MenuItem_Component = MenuItem_normalizeComponent(
  MenuItem,
  menu_MenuItem,
  MenuItem___vue_template_functional__,
  MenuItem___vue_styles__,
  MenuItem___vue_scopeId__,
  MenuItem___vue_module_identifier__
)

/* harmony default export */ var components_menu_MenuItem = (MenuItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/menu/ChatListMenu.vue

//
//
//
//
//
//
//
//





/* harmony default export */ var ChatListMenu = ({
  name: 'ChatListMenu',
  components: { WxMenu: components_menu_Menu, WxMenuItem: components_menu_MenuItem },
  props: ['position'],
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['currentChatId'])),
  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])(['closeMenu', 'closeChat']), {
    topChat: function topChat(e) {
      this.closeMenu();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97569038","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/ChatListMenu.vue
var ChatListMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wx-menu',{attrs:{"position":_vm.position}},[_c('wx-menu-item',{nativeOn:{"click":function($event){_vm.topChat($event)}}},[_vm._v("置顶")]),_vm._v(" "),_c('wx-menu-item',{nativeOn:{"click":function($event){_vm.closeChat($event)}}},[_vm._v("关闭聊天")])],1)}
var ChatListMenu_staticRenderFns = []
var ChatListMenu_esExports = { render: ChatListMenu_render, staticRenderFns: ChatListMenu_staticRenderFns }
/* harmony default export */ var menu_ChatListMenu = (ChatListMenu_esExports);
// CONCATENATED MODULE: ./src/components/menu/ChatListMenu.vue
var ChatListMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChatListMenu___vue_template_functional__ = false
/* styles */
var ChatListMenu___vue_styles__ = null
/* scopeId */
var ChatListMenu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChatListMenu___vue_module_identifier__ = null
var ChatListMenu_Component = ChatListMenu_normalizeComponent(
  ChatListMenu,
  menu_ChatListMenu,
  ChatListMenu___vue_template_functional__,
  ChatListMenu___vue_styles__,
  ChatListMenu___vue_scopeId__,
  ChatListMenu___vue_module_identifier__
)

/* harmony default export */ var components_menu_ChatListMenu = (ChatListMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/menu/ChatAreaMenu.vue

//
//
//
//
//
//





/* harmony default export */ var ChatAreaMenu = ({
  name: 'ChatAreaMenu',
  components: { WxMenu: components_menu_Menu, WxMenuItem: components_menu_MenuItem },
  props: ['position'],
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['currentChatId'])),
  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])(['clearHistory']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b947118","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/ChatAreaMenu.vue
var ChatAreaMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wx-menu',{attrs:{"position":_vm.position}},[_c('wx-menu-item',{nativeOn:{"click":function($event){_vm.clearHistory(_vm.currentChatId)}}},[_vm._v("清屏")])],1)}
var ChatAreaMenu_staticRenderFns = []
var ChatAreaMenu_esExports = { render: ChatAreaMenu_render, staticRenderFns: ChatAreaMenu_staticRenderFns }
/* harmony default export */ var menu_ChatAreaMenu = (ChatAreaMenu_esExports);
// CONCATENATED MODULE: ./src/components/menu/ChatAreaMenu.vue
var ChatAreaMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChatAreaMenu___vue_template_functional__ = false
/* styles */
var ChatAreaMenu___vue_styles__ = null
/* scopeId */
var ChatAreaMenu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChatAreaMenu___vue_module_identifier__ = null
var ChatAreaMenu_Component = ChatAreaMenu_normalizeComponent(
  ChatAreaMenu,
  menu_ChatAreaMenu,
  ChatAreaMenu___vue_template_functional__,
  ChatAreaMenu___vue_styles__,
  ChatAreaMenu___vue_scopeId__,
  ChatAreaMenu___vue_module_identifier__
)

/* harmony default export */ var components_menu_ChatAreaMenu = (ChatAreaMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/card/Card.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Card = ({
  name: 'Card',
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['cardStatus', 'cardPosition', 'cardChatId', 'contact'])),
  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])(['closeCard']), {
    // 防止疯狂提交commit
    _closeCard: function _closeCard() {
      this.cardStatus && this.$store.commit('closeCard');
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4059d5e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/Card.vue
var Card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm._closeCard),expression:"_closeCard"}],staticClass:"wx-card",class:{ 'is-show' : _vm.cardStatus },style:(_vm.cardPosition)},[(_vm.cardChatId == null)?_c('img',{staticClass:"wx-card__avatar",attrs:{"src":"static/yuxino.jpg","alt":""}}):_c('img',{staticClass:"wx-card__avatar",attrs:{"src":_vm.contact[_vm.cardChatId].avatar,"alt":""}}),_vm._v(" "),(_vm.cardChatId == null)?_c('div',{staticClass:"wx-card-info"},[_vm._v("\n    yuxino  "),_c('i',{staticClass:"iconfont wx-card-info__icon is-male icon-nanren"}),_vm._v(" "),_c('p',[_vm._v("备注: yuxino")]),_vm._v(" "),_c('p',[_vm._v("地区: 深圳")])]):_c('div',{staticClass:"wx-card-info"},[_vm._v("\n    "+_vm._s(_vm.contact[_vm.cardChatId].remarks || _vm.contact[_vm.cardChatId].userName)+"  "),_c('i',{staticClass:"iconfont wx-card-info__icon is-male icon-nanren"}),_vm._v(" "),_c('p',[_vm._v("备注: "+_vm._s(_vm.contact[_vm.cardChatId].bio)+" ")]),_vm._v(" "),_c('p',[_vm._v("地区: "+_vm._s(_vm.contact[_vm.cardChatId].location)+" ")])])])}
var Card_staticRenderFns = []
var Card_esExports = { render: Card_render, staticRenderFns: Card_staticRenderFns }
/* harmony default export */ var card_Card = (Card_esExports);
// CONCATENATED MODULE: ./src/components/card/Card.vue
function Card_injectStyle (ssrContext) {
  __webpack_require__("oweO")
}
var Card_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Card___vue_template_functional__ = false
/* styles */
var Card___vue_styles__ = Card_injectStyle
/* scopeId */
var Card___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Card___vue_module_identifier__ = null
var Card_Component = Card_normalizeComponent(
  Card,
  card_Card,
  Card___vue_template_functional__,
  Card___vue_styles__,
  Card___vue_scopeId__,
  Card___vue_module_identifier__
)

/* harmony default export */ var components_card_Card = (Card_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var App = ({
  name: 'App',
  components: { WxAside: components_aside_Aside, WxMain: components_main_Main, CopyRight: components_footer_CopyRight, ChatListMenu: components_menu_ChatListMenu, ChatAreaMenu: components_menu_ChatAreaMenu, Card: components_card_Card },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['currentMenu']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fb22de6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-app"},[_c('WxAside'),_vm._v(" "),_c('WxMain'),_vm._v(" "),_c('CopyRight'),_vm._v(" "),_c(_vm.currentMenu,{tag:"component"}),_vm._v(" "),_c('Card')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("N+Es")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/directives/ClickOutSide.js
var ClickOutSide = function ClickOutSide() {};

ClickOutSide.install = function (Vue, Options) {
  Vue.directive('click-outside', {
    bind: function bind(el, binding, vnode) {
      el.event = function (event) {
        // here I check that click was outside the el and his childrens
        if (!(el === event.target || el.contains(event.target))) {
          // and if it did, call method provided in attribute value
          vnode.context[binding.expression](event);
        }
      };
      document.body.addEventListener('click', el.event);
    },
    unbind: function unbind(el) {
      document.body.removeEventListener('click', el.event);
    }
  });
};

/* harmony default export */ var directives_ClickOutSide = (ClickOutSide);
// EXTERNAL MODULE: ./src/sass/main.scss
var main = __webpack_require__("HRs4");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// CONCATENATED MODULE: ./src/main.js






vue_esm["a" /* default */].config.devtools = true;
vue_esm["a" /* default */].config.productionTip = false;
vue_esm["a" /* default */].use(directives_ClickOutSide);

new vue_esm["a" /* default */]({ // eslint-disable-line no-new
  el: '#app',
  components: { App: src_App },
  store: src_store
});

/***/ }),

/***/ "NvS5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q9Et":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ql+W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UD+7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Voy+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WE++":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WsHK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "brbV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e50P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j4e9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oweO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qMp1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.dc1811290ac0f604dbe9.js